import { j as i } from "./jsx-runtime-3tyXYecC.mjs";
import { m as n } from "./tss-DN0acMKN.mjs";
const c = n()((s, t) => {
  const { verticalAlign: e, width: o } = t;
  return {
    root: {
      display: "inline-block",
      maxWidth: "100%",
      overflow: "hidden",
      textOverflow: "ellipsis",
      verticalAlign: e,
      whiteSpace: "nowrap",
      width: o
    }
  };
}), p = (s) => {
  const { id: t, verticalAlign: e, width: o = "auto", children: r } = s, { classes: a } = c({ verticalAlign: e, width: o });
  return /* @__PURE__ */ i.jsx("span", { className: a.root, "data-fabric-component": "TruncateV2", id: t, children: r });
};
export {
  p as T
};
//# sourceMappingURL=truncate-v2-BAMxYyA_.mjs.map
